module.exports = __webpack_public_path__ + "ipetbooking/admin/img/user_dbpic.1857db6f.svg";